// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Footer_navigation__IzxQb","social":"Footer_social__CyH3J","contact":"Footer_contact__229VA"};